<!-- 第一次登录时必读书本 -->
<template>
  <div class="books">
    <v-touch v-on:swipeleft="swipeleft" v-on:swiperight="swiperight">
      <div class="books_center">
        <div class="books_content" id="books_content">
          <img alt="" :src= src>
        </div>
      </div>
    </v-touch>
    <div style="display: flex;padding: 1rem;">
      <el-button @click="swiperight">上一页</el-button>
      <div class="page">第{{index+1}}页</div>
      <el-button @click="swipeleft">下一页</el-button>
    </div>
    <div style="text-align: center;width:100%;display: flex;margin: 0 auto;justify-content: center;">
      <el-button type="primary" class="close" @click="close">关闭</el-button>
        <el-button type="info" disabled v-if="num > 0" class="disabled">{{msg}}</el-button>
    </div>
    <!-- <el-button @click="back" type="primary">
      返回
    </el-button> -->
  </div>
</template>

<script>
import * as req from '@/utils/request'
import * as req2 from '@/utils/requestBOOK.js'
export default {
  data () {
    return {
      index: 0,
      pageList: [],
      time: 5000,
      num: 5,
      addTime: 5,
      // 本书的阅读记录
      readPage: []
    }
  },
  computed: {
    stationId: function () {
      return window.$gmdss.user_info.station_id
    },
    msg: function () {
      if (this.index === this.pageList.length - 1 && this.num === 0) {
        return '已读完, 点击进入主页'
      }
      if (this.num > 0) {
        return this.num + '秒后可滑动'
      }
      return '下一页'
    },
    src: function () {
      let index = this.index
      if (this.pageList.length < 1) {
        return ''
      }
      let requiredUrl = this.gmdss.loginBook
      let str = requiredUrl + this.stationId + '/' + this.pageList[index].path
      return str
    }
  },
  mounted () {
  },
  methods: {
    // 上一页
    swiperight () {
      this.stopCountDown()
      // document.getElementById('books_content').scrollTop = 0
      clearInterval(this.int)
      if (this.index === 0) {
        this.$message.error('已经是第一页')
        return
      }
      this.index--
    },
    swipeleft () {
      if (this.num > 0) {
        return
      }
      // document.getElementById('required_content').scrollTop = 0
      if (this.index === this.pageList.length - 1) {
        this.stopCountDown()
        this.int = 0
        let msg = {}
        msg.id = this.gmdss.user_info.id
        let data = {}
        // 页面防止再次进入
        this.gmdss.is_enter = false
        this.gmdss.user_info.is_enter = true
        data.is_enter = false
        msg.data = data
        let sendData = {}
        sendData.data = msg
        sendData.fn = this.recordFn
        sendData.vm = this
        req.Post('user/eidt_User', sendData)
        this.$router.push({path: '/index'})
        return
      }
      this.index++
      if (this.readPage.indexOf(this.index) < 0) {
        this.countDown()
      }
    },
    // 倒计时
    countDown () {
      this.stopCountDown()
      this.num = 5
      let _this = this
      this.int = setInterval(function () {
        _this.clock()
      }, 1000)
    },
    clock () {
      if (this.num > 0) {
        this.num--
        // return
      }
      if (this.num === 0) {
        this.stopCountDown()
        // 如果读完这本书发送读完的消息,修改用户是否为第一次登陆的状态
        if (this.index === this.pageList.length - 1) {
          // 发送消息修改用户是否为第一次登陆的状态
          // 保存成功后调用close
          let msg = {}
          msg.id = this.gmdss.user_info.id
          let data = {}
          data.is_enter = false
          msg.data = data
          let sendData = {}
          sendData.data = msg
          sendData.fn = this.recordFn
          sendData.vm = this
          req.Post('user/eidt_User', sendData)
        }
      }
    },
    recordFn (data) {
      if (data === null) {
        alert('服务器未连接')
        return
      }
      if (data.err_code !== 0) {
        alert(data.err_msg)
      }
    },
    stopCountDown () {
      clearInterval(this.int)
      // console.info('stop time', this.int)
      this.int = 0
      this.num = 0
    },
    // 关闭, 返回登录界面
    close () {
      // window.location.href = window.$gmdss.loginURL
    },
    // 根据职位id获取书本内容
    getRequired () {
      let msg = {}
      msg.station_id = this.stationId
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.getRequiredfn
      sendData.vm = this
      req2.Post('fileMenuData/get_loginBook', sendData)
    },
    getRequiredfn (data) {
      if (data === null) {
        alert('服务器未连接')
        window.location.href = window.$gmdss.loginURL
        return
      }
      if (data.err_code !== 0) {
        alert(data.err_msg)
        window.location.href = window.$gmdss.loginURL
      }
      let page = data.list
      let list = page.page_list
      this.pageList = list
      if (list.length > 0) {
        this.countDown()
      }
    }
  },
  created () {
  },
  // 路由进来前
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getRequired()
    })
  },
  // 路由跳出后
  beforeRouteLeave (to, from, next) {
    this.stopCountDown()
    next()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.books {
  width: 100%;
  /* display: flex; */
}
.books_content > img {
  width: 100%;
  height: 100%;
}
.page{
  width: 100%;
  text-align: center;
}
.books_top{
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/required.vue